export const META_DATA = {
    form: {
        title: "Log In",
    },
};
